module.exports = __webpack_public_path__ + "img/03-03_Acting  courageously.437e0483.svg";